import { useQuery } from 'react-query';
import {
  UseSignatureConsultPUBOptions,
  UseSignatureConsultPUBParams,
  UseSignatureConsultPUBResponse,
} from './useSignatureConsultPUB.types';
import { querySignatureConsultPUB } from './useSignatureConsultPUB.query';

export const SIGNATURE_CONSULT_PUB_QUERY_KEY = 'SIGNATURE_CONSULT_PUB';

export const useSignatureConsultPUB = (
  params: UseSignatureConsultPUBParams,
  options?: UseSignatureConsultPUBOptions
) => {
  return useQuery<UseSignatureConsultPUBResponse, Error>(
    SIGNATURE_CONSULT_PUB_QUERY_KEY,
    () => querySignatureConsultPUB(params),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
